import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { IconBar, RevenueTab, ResultArea, VariableCostsTab, FixedCostsTab, MerchandiseCostTab, Footer, SendTab } from './';

const FinancialSetupContainer = styled.div`
  display: grid;
  background-color: white;
  margin: auto;
  opacity: 0.92;
  width: 80%;
  @media (min-width:1281px) {
    grid-template-columns: 65% auto;
  };
  margin-top: 48px;
  margin-bottom: 48px;
  border: 1px solid #8080803d;
  border-radius: 4px;
`;
const numberfy = (value) => {
  let formattedValue = value.replace(",", ".") || 0
  return parseFloat(formattedValue)
}

const variableCosts = (financialSetup) => {
  const revenueNumb = numberfy(financialSetup.revenue)
  const taxesNumb = numberfy(financialSetup.variableCosts.taxes)
  const cardsNumb = numberfy(financialSetup.variableCosts.cards) 
  const comissionsNumb = numberfy(financialSetup.variableCosts.comissions)
  let variableCostsPercentage = taxesNumb + cardsNumb + comissionsNumb
  let variableCosts = revenueNumb * (variableCostsPercentage) / 100
  let variableCostsString = variableCosts.toString(10)
  const variableCostsTotal = {number: variableCosts, string: variableCostsString.replace(".", ","), percentage: variableCostsPercentage}
  return variableCostsTotal
}

const fixedCosts = (financialSetup) => {
  const hrNumb = numberfy(financialSetup.fixedCosts.HR)
  const adminNumb = numberfy(financialSetup.fixedCosts.admin)
  const occupationalNumb = numberfy(financialSetup.fixedCosts.occupational)
  const maintenanceNumb = numberfy(financialSetup.fixedCosts.maintenance)
  const othersNumb = numberfy(financialSetup.fixedCosts.others)

  let fixedCosts = hrNumb + adminNumb + occupationalNumb + maintenanceNumb + othersNumb
  let fixedCostsString = fixedCosts.toString(10)
  const fixedCostsTotal = {number: fixedCosts, string: fixedCostsString.replace(".", ",")}
  return fixedCostsTotal
}

function FinancialSetup(props) {
  const varCosts = variableCosts(props.financialSetup)
  const revenue = numberfy(props.financialSetup.revenue)
  const fixCosts = fixedCosts(props.financialSetup)

  return (
    <FinancialSetupContainer>
      <IconBar/>
      {props.activeTab === 1 ? <RevenueTab /> : props.activeTab === 2 ? <VariableCostsTab/> : props.activeTab === 3 ? <FixedCostsTab/> : props.activeTab === 4 ? <MerchandiseCostTab/> : props.activeTab === 5 ? <SendTab fixedCosts={fixCosts.number} variableCosts={varCosts} /> : ""}
      <ResultArea revenue={revenue} variableCosts={varCosts} fixedCosts={fixCosts}/>
      <Footer/>
    </FinancialSetupContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    activeTab: state.reducers.activeTab,
    financialSetup: state.reducers.financialSetup
  }
}

export default connect(
  mapStateToProps,
  null
)(FinancialSetup)